/**
 * index.js
 *
 * @Author: jruif
 * @Date: 2017/7/10 下午3:05
 */

import Box from './Box';

export default Box;



// WEBPACK FOOTER //
// ./src/box/index.js